var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.location.label))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.location.description))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }